export default __webpack_public_path__ + "static/media/CFD299.7fa69092.jpg";